import React, {Component} from 'react';
import PropTypes from 'prop-types';

import {topoUtils} from '../utils/topo-utils';
import {geoUtils} from '../utils/geo-utils';

class StateCountyBorders extends Component {

  shouldComponentUpdate(nextProps){
    const widthDifferent = nextProps.width !== this.props.width;
    const heightDifferent = nextProps.height !== this.props.height;
    const stateDifferent = nextProps.stateFips !== this.props.stateFips;

    return widthDifferent || heightDifferent || stateDifferent;
  }

  render() {
    const topo = topoUtils.getStateTopography(this.props.stateFips);
    const path = geoUtils.getAlbersStatePath(this.props.stateFips, this.props.width, this.props.height);

    return (
      <g className="StateCountyBorders">
        <path d={path(topo.borders)}></path>
      </g>
    )
  }
}

StateCountyBorders.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  stateFips: PropTypes.number
};

export default StateCountyBorders


// WEBPACK FOOTER //
// ./src/charts/Map/StateCountyBorders.js